import { Badge } from 'slab'

import { type SubmissionMethod } from './types'
import { assertUnreachable } from '../../utils'

export default function EnrollmentSubmissionMethodPill ({
  submissionMethod,
  assigneeName,
}: {
  submissionMethod: SubmissionMethod | undefined,
  assigneeName: string | undefined,
}) {
  if (!submissionMethod) {
    return
  }

  let text = ''
  switch (submissionMethod) {
    case 'manual':
      text = '💪 Manual submission'
      if (assigneeName && assigneeName !== 'Unassigned') {
        text += ` (by ${assigneeName})`
      }
      break
    case 'off_thatch':
      text = '🏕️ Enrolled off-Thatch'
      break
    case 'auto_renewal':
      text = '😴 Auto-renewal'
      break
    case 'member_plan_change_with_carrier':
      text = '🔄 Member plan change with carrier'
      break
    case 'ambetter_embark':
    case 'ambetter_equity':
    case 'anthem':
    case 'kaiser':
    case 'oscar':
    case 'bsca':
    case 'vsp_browser_automation':
    case 'renaissance_browser_automation':
    case 'guardian_browser_automation':
    case 'uhc_browser_automation':
    case 'health_sherpa_automation':
    case 'bsca_browser_automation':
      text = '🤖 Automated submission'
      break
    default:
      assertUnreachable(submissionMethod)
  }

  return (
    <Badge
      type='neutral'
    >
      {text}
    </Badge>
  )
}
